

export const frontMatter = {};
export const contentTitle = 'InputField';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-components-input-field-mdx-03e.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Features",
  "id": "features",
  "level": 3
}, {
  "value": "Live example",
  "id": "live-example",
  "level": 3
}, {
  "value": "Label Alignment",
  "id": "label-alignment",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "inputfield",
        children: "InputField"
      })
    }), "\n", _jsx(_components.p, {
      children: "An input box with an associated label, error message, and context help. See also:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/jui/docs/components/Input",
          children: "Input"
        }), ", for a simple input box, without these extra parts."]
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/jui/docs/components/SearchInput",
          children: "SearchInput"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "features",
      children: "Features"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["A label to be associated with the input, placed before or above the input. ", _jsx(_components.a, {
          href: "https://jetbrains.github.io/ui/controls/input_field/#label",
          children: "See the spec"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Error message shown as a tooltip. ", _jsx(_components.a, {
          href: "https://jetbrains.github.io/ui/controls/input_field/#27",
          children: "See the spec"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Context help. ", _jsx(_components.a, {
          href: "https://jetbrains.github.io/ui/principles/context_help/#07",
          children: "See the spec"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "live-example",
      children: "Live example"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        metastring: "live themed",
        live: true,
        children: "<div\n  style={{ display: \"inline-flex\", flexDirection: \"column\", alignItems: \"end\" }}\n>\n  <InputField\n    label=\"Label:\"\n    placeholder=\"Placeholder\"\n    contextHelp=\"Context help\"\n  />\n  <br />\n  <InputField\n    label=\"Error:\"\n    validationState=\"error\"\n    placeholder=\"Error shown on hover\"\n    validationMessage=\"Error message\"\n  />\n  <br />\n  <InputField\n    label=\"Warning:\"\n    validationState=\"warning\"\n    placeholder=\"Warning shown on hover\"\n    validationMessage=\"Warning message\"\n  />\n  <br />\n\n  <InputField label=\"Label above:\" labelPlacement=\"above\" />\n</div>\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "label-alignment",
      children: "Label Alignment"
    }), "\n", _jsxs(_components.p, {
      children: ["Use ", _jsx(_components.code, {
        children: "LabeledControlsAlignmentProvider"
      }), " to align InputField with other labeled controls, according to\n", _jsx(_components.a, {
        href: "https://jetbrains.github.io/ui/principles/layout/#05",
        children: "the design guidelines"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        metastring: "live themed",
        live: true,
        children: "<LabeledControlsAlignmentProvider>\n  <div\n    style={{\n      display: \"flex\",\n      flexDirection: \"column\",\n      gap: \"1rem\",\n      width: 400,\n    }}\n  >\n    <InputField label=\"Host name:\" />\n    <ComboBox label=\"Port number:\">\n      <Item key=\"80\">80</Item>\n    </ComboBox>\n  </div>\n</LabeledControlsAlignmentProvider>\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

